import React, { useState } from 'react'
import { getImages } from '../../Common/const'
import { motion } from "framer-motion";
import UseScrollReveal from '../../Common/UseScrollReveal';
import BookAppointmentModal from './BookAppointmentModal';
import ModalLayout from '../../Common/ModalLayout';
import SeoMeta from '../../Common/SeoMeta';

const MclarenRepair = () => {
    const [position, setPosition] = useState({ x: 0, y: 0 });
    const handleMouseMove = (e) => {
        const { clientX, clientY, currentTarget } = e;
        const { left, top, width, height } = currentTarget.getBoundingClientRect();
        const x = ((clientX - left) / width - 2) * 20;
        const y = ((clientY - top) / height - 1) * 20;
        const bgX = ((clientX - left) / width - 5) * 30;
        const bgY = ((clientY - top) / height - 0.5) * 30;
        setPosition({ x, y, bgX, bgY });
    };
    UseScrollReveal()
    // 
    const [openBookAppointment, setOpenBookAppointment] = useState(false);
    const handleBookAppointment = () => {
        setOpenBookAppointment(true);
        document.body.classList.add('body-overflow');
    }
    const closeBookAppointment = () => {
        setOpenBookAppointment(false)
        document.body.classList.remove('body-overflow');
    }
    return (
        <>
            <SeoMeta
                title="McLaren Service & Repair in Tampa, FL | European Exotic Center"
                description="Looking for McLaren repair services in Tampa? European Exotic Center can help with everything from oil changes to exhaust repair."
                keywords=""
                ogTitle="McLaren Service & Repair in Tampa, FL | European Exotic Center"
                ogDescription="Looking for McLaren repair services in Tampa? European Exotic Center can help with everything from oil changes to exhaust repair."
            />
            <section className="common-banner-wrap repair-banner">
                <img src={getImages('services/McLaren-Service-hero.jpg')} alt='McLaren' />
                <div className="container">
                    <div className='common-banner-pos pt-140 text-center'>
                        <h1 className='banner-lg-title text-uppercase wow reveal fadeInUp'>McLaren Service</h1>
                        <div className='md-title font-2em fw-400 text-center mt-3 mb-4 wow reveal fadeInUp'>in the Tampa Bay Area</div>
                        <div className='my-4 wow reveal fadeInUp'>
                            <button type='button' className='orange-white-btn lg-btn w-330 font-1-2em fw-700 text-uppercase' onClick={handleBookAppointment}>Schedule Service</button>
                        </div>
                    </div>
                </div>
            </section>
            <section className='exotic-car-wrap'>
                <div className='container'>
                    <div className='row align-items-center'>
                        <div className='col-12 wow reveal fadeInLeft'>
                            <div className='md-title fw-700 text-uppercase mb-md-5 mb-3'>McLaren Service in Tampa, FL</div>
                            <div className='common-text pb-3'>
                                <p>At European Exotic Center, we know how important it is to keep a vehicle running at peak performance. That’s why our world-class service center is well-equipped and highly capable. We can help vehicle owners with routine oil changes, timing belt services, clutch replacements and many other popular automotive services. We have the proper McLaren equipment to service all McLaren models.</p>
                            </div>
                            <div className='mt-5 wow reveal fadeInUp d-none d-md-block'>
                                <button type='button' className='orange-white-btn lg-btn w-330 font-1-2em fw-700 text-uppercase' onClick={handleBookAppointment}>Schedule Service</button>
                            </div>
                        </div>
                        {/* <div className='col-md-6 text-end wow reveal fadeInRight mt-md-0 mt-4'>
                            <img src={getImages('bitmap-copy-2.png')} alt='' />
                        </div> */}
                    </div>
                </div>
            </section>
            <section className='maintenance-services-wrap'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-md-6 pe-5 pt-2 wow reveal fadeInLeft'>
                            <div className='sm-title text-uppercase font-2-5em mb-md-4 mb-3'>Auto Services We Offer</div>
                            <div className='common-text'>
                                <p>No matter what you need, you can rest assured that our excellent team can get the job done right.<br/>
Our services include:</p>
                            </div>
                        </div>
                        <div className='col-md-6 wow reveal fadeInRight mt-md-0 mt-5'>
                            <ul className='oe-list-flex'>
                                <li>
                                    <div className='d-flex align-items-center'>
                                        <div className='oe-icon'>
                                            <img src={getImages('arrow.svg')} />
                                        </div>
                                        <div className='sm-title eurostile text-uppercase pt-1'>Annual Services, including major services</div>
                                    </div>
                                </li>
                                <li>
                                    <div className='d-flex align-items-center'>
                                        <div className='oe-icon'>
                                            <img src={getImages('arrow.svg')} />
                                        </div>
                                        <div className='sm-title eurostile text-uppercase pt-1'>MDS Diagnostic Tool</div>
                                    </div>
                                </li>
                                <li>
                                    <div className='d-flex align-items-center'>
                                        <div className='oe-icon'>
                                            <img src={getImages('arrow.svg')} />
                                        </div>
                                        <div className='sm-title eurostile text-uppercase pt-1'>Suspension Accumulator replacement</div>
                                    </div>
                                </li>
                                <li>
                                    <div className='d-flex align-items-center'>
                                        <div className='oe-icon'>
                                            <img src={getImages('arrow.svg')} />
                                        </div>
                                        <div className='sm-title eurostile text-uppercase pt-1'>Cam Variator Replacements</div>
                                    </div>
                                </li>
                                <li>
                                    <div className='d-flex align-items-center'>
                                        <div className='oe-icon'>
                                            <img src={getImages('arrow.svg')} />
                                        </div>
                                        <div className='sm-title eurostile text-uppercase pt-1'>Battery and electrical system diagnostics</div>
                                    </div>
                                </li>
                                <li>
                                    <div className='d-flex align-items-center'>
                                        <div className='oe-icon'>
                                            <img src={getImages('arrow.svg')} />
                                        </div>
                                        <div className='sm-title eurostile text-uppercase pt-1'>And many more services!</div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <div className='col-12 wow reveal fadeInUp mt-md-5 mt-4 pt-2'>
                            <div className='sm-title text-uppercase font-2-5em mb-4'>Why Choose Us For McLaren Auto Repairs</div>
                            <div className='common-text'>
                                <p>Our pre-owned dealership, located in Tampa, Florida, has served the Tampa Bay area for more than 10 years in all their exotic car needs, including Ferraris, Lamborghinis, Porches, and more. We also serve people in nearby locations like Sarasota and Orlando with finding their next exotic car and any auto services they may need to keep it in tip-top shape.<br/>
Not only do we care for your vehicle, we're competitively priced. Our McLaren services are sometimes half the cost of nearby dealerships, who frankly aren't as good as we are. </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className='book-appointment-wrap dtl-book-appoint-wrap'>
                <div className="mouse-container"
                    onMouseMove={handleMouseMove}>
                    <motion.div
                        className="mouse-background"
                        style={{
                            background: `url(${getImages('ferrari-schedule-bg.webp')}) no-repeat center/cover`
                        }}
                        animate={{
                            x: position.bgX,
                            y: position.bgY,
                        }}
                        transition={{ type: "tween", stiffness: 50 }}
                    />

                    <div className='w-100 text-center mouse-text'>
                        <div className='container'>
                            <div className='banner-lg-title font-3-5em text-uppercase wow reveal fadeInUp'>schedule an appointment</div>
                            <div className='sm-title font-1-2em mt-3 wow reveal fadeInUp'>We would love to work with you and have the opportunity to service your unique vehicle.</div>
                            <div className="my-4 wow reveal fadeInUp">
                                <button type="button" className="orange-white-btn lg-btn w-330 font-1-2em fw-700 text-uppercase" onClick={handleBookAppointment}>Schedule Service</button>
                            </div>
                            <div className='text-center wow reveal fadeInUp'>
                                <a href='tel:8135880905' className='sm-title font-1-5em fw-400 avenir-next text-white'>
                                    Or Call (813) 588-0905
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className='fs-schedule-services-wrap'>
                <div className='container'>
                    <div className='banner-lg-title font-2-5em mb-md-4 mb-3 pb-md-2 text-uppercase wow reveal fadeInUp'>Schedule Service in Tampa, FL</div>
                    <div className='sm-title font-1-2em wow reveal fadeInUp'>It’s easy to schedule a service appointment at European Exotic Center. We know our customers lead busy lives, which is why we make it a priority to make the service experience as convenient as possible. Vehicle owners can make an appointment to take their vehicle in for service, just give us a call at (813) 588-0905.</div>
                </div>
            </section>
            {openBookAppointment &&
                <ModalLayout open={openBookAppointment} close={closeBookAppointment} darkThemeCls='true' modalWidth={1030}>
                    <BookAppointmentModal close={closeBookAppointment} />
                </ModalLayout>
            }
        </>
    )
}
export default MclarenRepair
